<script>
    export let minWidth = "600px";
    export let className = "";
    export let w = "2/3";
</script>

<div class="block p-6 bg-white border border-gray-200 rounded-lg shadow w-{w} mb-2 {className}" style="min-width: {minWidth}">
    <slot />
</div>